export const isOfflineMode = (): boolean => {
  return import.meta.env.VITE_OFFLINE_MODE === "true";
};
